import React from "react";

import styles from "./DeleteModal.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faX } from "@fortawesome/free-solid-svg-icons";

function DeleteConfirmationModal({ onClose, onDelete }) {
  return (
    <div className={styles.container}>
      <div className={styles.ctn}>
        <button onClick={onClose}>
          <FontAwesomeIcon style={{ cursor: "pointer" }} icon={faX} />
        </button>
        <h1>Are You sure you want to delete?</h1>
        <div className={styles.buttons}>
          <button onClick={onDelete} className={styles.confirm}>
            Yes
          </button>
          <button onClick={onClose} className={styles.reject}>
            No
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeleteConfirmationModal;
